<template>
  <div>
    <Modal :title="title" v-model="modalShow">
      <div class="req-form">
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="卷名称">
            <Input v-model="volumeData.name" :disabled="true" style="width: 300px" />
          </FormItem>
          <FormItem label="当前大小(GiB)">
            <InputNumber v-model="volumeData.size" :disabled="true" style="margin-left: 10px"></InputNumber>
          </FormItem>
          <FormItem label="新大小(GiB)" prop="new_size">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>新大小必须大于当前大小！</p>
              </div>
            </tooltip>
            <InputNumber :min="1" v-model="reqForm.new_size" style="margin-left: 10px"></InputNumber>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
export default {
  name: 'volume-extend',
  data () {
    return {
      title: '扩展卷',
      volumeData: {},
      modalShow: false,
      submitting: false,
      reqForm: {
        new_size: null
      },
      reqRule: {
        new_size: [
          { required: true, type: 'number', message: '新大小不能为空', trigger: 'blur' }
        ]
      },
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id) {
      detailPrivateCloudVolume(id).then(res => {
        this.volumeData = res.data.volume
        this.modalShow = true
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          if (this.volumeData.size >= this.reqForm.new_size) {
            this.$Notice.warning({
              title: '新大小必须大于当前大小！'
            })
            return false
          }
          let reqData = {
            'os-extend': this.reqForm
          }
          this.submitting = true
          actionPrivateCloudVolume(reqData, this.volumeData.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
